import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/components/ThemeContext";
import LandingPage from "@/pages/LandingPage";
import AuditFlow from "@/pages/AuditFlow";
import ReportPage from "@/pages/ReportPage";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <ThemeProvider>
      <div className="App min-h-screen" style={{ backgroundColor: 'var(--rhz-bg)' }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/audit/:auditId" element={<AuditFlow />} />
            <Route path="/report/:auditId" element={<ReportPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
